import React from 'react';
import { useTranslation } from "react-i18next";

const Footer = ({ absolutePosition }) => {
  const [t] = useTranslation("footer")

  const currentYear = new Date().getFullYear();  // Obtener el año actual

  return (<>
    <div className='footer-separator'></div>



    <div className={`${absolutePosition ? 'footer-absolute' : 'footer-container'} custom-footer`}>
      <span className='footer-phone-container'>

        <span className=''>{t("footer.telephoneText")}:</span> <span className='font-bold color-custom-secondary'>928 050 050</span> | <span className='font-bold color-custom-secondary'>922 050 050</span> | <span className='font-bold color-custom-secondary'>Ext. 4</span>


      </span>
      <span className='footer-powered-by'>
        © {currentYear} Powered by
        <a
          href="https://www.linksoluciones.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginLeft: '5px' }}
          className='custom-secondary-link'
        >
          Link Soluciones
        </a>
      </span>
    </div>
  </>
  );
};

export default Footer;
